<template>
	<div class="container-xl">
		<main class="py-4">
            <div class="app-card app-card-orders-table shadow-sm mb-5" v-if="offlineDrafts !== null && offlineDrafts.length > 0 && showOfflineDrafts">

                <div class="app-card-header p-3">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-auto">
                            <h5 class="app-card-title">{{  __('form.form-offline-data-found')  }}</h5>
                        </div><!--//col-->
				    </div><!--//row-->
				</div>

                <div class="app-card-body">
                    <div class="table-responsive">
                        <table class="table app-table-hover mb-0 text-left">
                            <thead>
                                <tr>
                                    <th class="cell">Sessie</th>
                                    <th class="cell">Naam</th>
                                    <th class="cell" colspan="3">Opgeslagen op</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in offlineDrafts" v-bind:key="item.offline_id">
                                    <td class="cell">{{ new Date(item.data.date).toLocaleDateString("nl-NL", { day: 'numeric' }) + "-" + new Date(item.data.date).toLocaleDateString("nl-NL", { month: '2-digit' }) }}<br/>{{ item.data.session_start }}</td>
                                    <td class="cell">{{ item.data.participant_name }}</td>
									<td class="cell">{{ new Date(item.updated_at).toLocaleTimeString('nl-NL') }}</td>
                                    <td class="cell"><button @click="restoreFromLocalDraft(item.offline_id)" class="btn-sm app-btn-secondary">Herstel</button></td>
                                    <td class="cell"><button @click="deleteFromLocalDraftWithConfirmation(item.offline_id)" class="btn-sm app-btn-danger">Wis</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <validation-observer ref="observer" v-slot:>
	            <form ref="analysisForm" autocomplete="off" @submit.prevent="saveForm()">
                    <input type="hidden" name="title" id="title" v-model="filledQuestionnaire.title">
					<div class="row g-3 mb-4 align-items-center justify-content-between">
						<div class="col-auto">
							<h1 class="app-page-title mb-0">{{ questionnaire.name }}</h1>
						</div>
						<div class="col-auto">
							<div class="page-utilities">
								<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
									<div class="col-auto">
										<button type="submit" class="btn btn-outline-success">
											<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
												<path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
											</svg>
											{{ __('questionnaires.save') }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="card mb-3">
								<div class="card-body">
									<div class="row">
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Bedrijfsnaam" tag="div">
												<label for="company_name" class="form-label">Bedrijfsnaam</label>
												<input :class="{'is-invalid': errors.length}" type="text" class="form-control" id="company_name" v-model="filledQuestionnaire.company_name">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
                                        <div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Plannummer" tag="div">
												<label for="project_code" class="form-label">Plannummer</label>
												<input :class="{'is-invalid': errors.length}" disabled type="text" class="form-control" id="project_code" v-model="filledQuestionnaire.project_code">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-6">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Locatie" rules="required" tag="div">
												<label for="location" class="form-label">Locatie</label>
												<input :class="{'is-invalid': errors.length}" type="text" class="form-control" id="location" v-model="filledQuestionnaire.location">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Naam cursist" rules="required" tag="div">
												<label for="student_name" class="form-label">Naam cursist</label>
												<input :class="{'is-invalid': errors.length}" type="text" class="form-control" id="student_name" v-model="filledQuestionnaire.participant_name">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
                                            <validation-provider :rules="filledQuestionnaire.was_present ? 'required': ''" name="Geldig rijbewijs" v-slot="{ errors }" tag="div">
                                                <label class="form-label">Geldig rijbewijs?</label>
                                                <div class="form-check">
                                                    <input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="driving-licence" :value="true" v-model="filledQuestionnaire.has_valid_driver_license" id="driving-licence1">
                                                    <label class="form-check-label" for="driving-licence1">
                                                        {{ __('questionnaires.q-boolean-yes') }}
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="driving-licence" :value="false" v-model="filledQuestionnaire.has_valid_driver_license" id="driving-licence2">
                                                    <label class="form-check-label" for="driving-licence2">
                                                        {{ __('questionnaires.q-boolean-no') }}
                                                    </label>
                                                </div>
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
										</div>
                                        <div class="col-md-3">
											<validation-provider rules="required" name="Is aanwezig" v-slot="{ errors }" tag="div">
                                                <label class="form-label">Aanwezig?</label>
                                                <div class="form-check">
                                                    <input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="was-present" :value="true" v-model="filledQuestionnaire.was_present" id="was_present1">
                                                    <label class="form-check-label" for="was_present1">
                                                        {{ __('questionnaires.q-boolean-yes') }}
                                                    </label>
                                                </div>
                                                <div class="form-check">
                                                    <input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="was-present" :value="false" v-model="filledQuestionnaire.was_present" id="was_present2">
                                                    <label class="form-check-label" for="was_present2">
                                                        {{ __('questionnaires.q-boolean-no') }}
                                                    </label>
                                                </div>
                                                <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
                                            </validation-provider>
										</div>
									</div>
									<div class="row">
                                        <div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Telefoonnummer cursist" tag="div">
												<label for="date" class="form-label">Telefoonnummer cursist</label>
												<input :class="{'is-invalid': errors.length}" type="text" class="form-control" v-model="filledQuestionnaire.participant_phone">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="datum" rules="required" tag="div">
												<label for="date" class="form-label">Datum</label>
												<input :class="{'is-invalid': errors.length}" type="date" class="form-control" id="date" v-model="filledQuestionnaire.date">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Starttijd" rules="required" tag="div">
												<label for="start_time" class="form-label">Starttijd</label>
                                                    <span class="time-setter" @click="setSessionStartTime('down')">10..NU</span>
                                                    <span class="time-setter" @click="setSessionStartTime()">NU</span>
                                                    <span class="time-setter" @click="setSessionStartTime('up')">NU..10</span>
												<input :class="{'is-invalid': errors.length}"  type="time" class="form-control" id="start_time" v-model="start_session">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Eindtijd" rules="required" tag="div">
												<label for="end_time" class="form-label">Eindtijd</label>
												<input :class="{'is-invalid': errors.length}"  type="time" class="form-control" id="end_time" v-model="filledQuestionnaire.session_end">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
									</div>
									<div class="row">
                                        <div class="col-md-6">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="E-mailadres cursist" tag="div">
												<label for="date" class="form-label">E-mail cursist</label>
												<input :class="{'is-invalid': errors.length}" type="text" class="form-control" v-model="filledQuestionnaire.participant_email">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Naam instructeur" rules="required" tag="div">
												<label for="instructor_name" class="form-label">Naam instructeur</label>
												<input type="text" disabled class="form-control" id="instructor_name" v-model="filledQuestionnaire.instructor_name">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
										<div class="col-md-3">
		                                    <validation-provider v-slot="{ errors }" class="mb-3" name="Wrm-nummer" tag="div">
												<label for="wrm-number" class="form-label">Wrm-nummer</label>
												<input :class="{'is-invalid': errors.length}" type="text" disabled class="form-control" id="wrm-number" v-model="filledQuestionnaire.wrm_number">
		                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
		                                    </validation-provider>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-for="section in filledQuestionnaire.answers" class="col-md-12">
							<div class="mb-3">
								<h5 class="fw-bolder">{{ section.title }} <span class="section-score" v-if="section.averageScore > 0">({{ section.averageScore }})</span></h5>
							</div>
							<div class="row">
								<div class="col-md-12" v-for="(question, index) in section.questions">
									<div v-if="question.type === 'BOOLEAN'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
													<div class="form-check" v-for="option in question.options">
														<input class="form-check-input" :value="option.body" type="radio" :name="question.id" v-model="question.answer" :id="question.id + option.sequence">
														<label class="form-check-label" :for="question.id + option.sequence">
															{{ option.body }}
														</label>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'SINGLE_CHOICE'
                                        || question.type === '3_POINT_GRADING_SCALE'
                                        || question.type === '4_POINT_GRADING_SCALE'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<span class="fw-bolder question-title" v-if="question.showNa" style="float:left;">{{ question.body }}</span>
                                                    <span class="fw-bolder question-title" v-else>{{ question.body }}</span>
                                                    <div class="form-check" v-if="question.showNa">
														<input class="form-check-input option-na-input" type="radio" value="0" @change="calculateScoreHandler" v-model="question.answer" :name="question.id" :id="question.id + '_NA'">
														<label class="form-check-label option-na-label" :for="question.id + '_NA'">
															{{ __('questionnaires.question-option-na') }}
														</label>
													</div>
													<div class="form-check" v-for="option in question.options">
														<input class="form-check-input" type="radio" :value="option.body" @change="calculateScoreHandler" v-model="question.answer" :name="question.id" :id="question.id + option.sequence">
														<label class="form-check-label" :for="question.id + option.sequence">
															{{ option.body }}
														</label>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'MULTI_CHOICE'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
													<div class="form-check" v-for="option in question.options" v-bind:key="option.sequence">
														<input class="form-check-input" type="checkbox" :value="option.body" v-model="question.answer" :id="question.id + '-' + option.sequence">
														<label class="form-check-label" :for="question.id + '-' + option.sequence">
															{{ option.body }}
														</label>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'TEXT'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
                                                    <input v-if="question.textLimit < 255" type="text" :class="{'is-invalid': errors.length}" v-model="question.answer"  class="form-control"/>
                                                    <textarea v-else :class="{'is-invalid': errors.length}" v-model="question.answer"  class="form-control" rows="5"></textarea>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'NUMBER'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
													<div class="row">
														<div class="col-md-5">
															<input v-if="question.hasMinMax" :class="{'is-invalid': errors.length}" v-model="question.answer" type="number" :max="question.maxValue" :min="question.minValue" class="form-control">
															<input v-else :class="{'is-invalid': errors.length}" v-model="question.answer" type="number" class="form-control">
														</div>
														<div v-if="question.hasUnits" class="col-md-1">
															<p class="mt-2 mb-2 fw-bolder">{{ question.units }}</p>
														</div>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'DATE'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
													<div class="row">
														<div class="col-md-4">
															<input :class="{'is-invalid': errors.length}" v-model="question.answer" type="date" class="form-control">
														</div>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>

									<div v-if="question.type === 'TIME'" class="mb-3">
										<div class="card">
											<div class="card-body">
												<validation-provider :rules="question.required && filledQuestionnaire.was_present ? 'required': ''" :name="question.body" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ question.body }}</p>
													<div class="row">
														<div class="col-md-4">
															<input :class="{'is-invalid': errors.length}" v-model="question.answer" type="time" class="form-control">
														</div>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

                        <div v-if="questionnaire.show_has_passed && filledQuestionnaire.was_present" class="col-md-12">
							<div class="mb-3">
                                <hr v-if="filledQuestionnaire.totalAverageScore > 0" :class="filledQuestionnaire.totalAverageScore > 5.5 ? 'bar-score-positive' : 'bar-score-negative'"></hr>
								<h5 class="fw-bolder">{{ __('questionnaires.final-verdict-section-title') }}</h5>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="mb-3">
										<div class="card">
											<div class="card-body">
                                                <validation-provider rules="required" name="Eindbeoordeling" v-slot="{ errors }" tag="div">
													<p class="fw-bolder">{{ __('questionnaires.final-verdict-text') }}</p>
													<div class="form-check">
														<input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="has_passed" :value="true" v-model="filledQuestionnaire.has_passed" id="has-passed-true">
														<label class="form-check-label" for="has-passed-true">
															{{ __('questionnaires.q-boolean-yes') }}
														</label>
													</div>
													<div class="form-check">
														<input :class="{'is-invalid': errors.length}" class="form-check-input" type="radio" name="has_passed" :value="false" v-model="filledQuestionnaire.has_passed" id="has-passed-false">
														<label class="form-check-label" for="has-passed-false">
															{{ __('questionnaires.q-boolean-no') }}
														</label>
													</div>
													<span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0] }}</span>
												</validation-provider>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
					</div>
		            <div class="row">
                        <div class="col-md-12 mt-4">
                            <p>{{ questionnaire.footer_text }}</p>
                            <input type="hidden" name="footer_text" id="footer_text" v-model="filledQuestionnaire.footer_text">
                        </div>
			            <div class="col-md-6">
				            <div class="d-flex justify-content-between align-items-center mb-2">
					            <p class="fw-bolder m-0">Handtekening instructeur</p>
					            <button type="button" class="btn btn-link" @click="$refs.instructorSignaturePad.undoSignature()">{{ __('actions.undo') }}</button>
				            </div>
                            <img v-if="filledQuestionnaire.instructor_signature" :src="filledQuestionnaire.instructor_signature" style="min-height: 200px; width: 100%;">
				            <VueSignaturePad v-else
					            id="instructorSignature"
					            width="100%"
					            height="300px"
					            ref="instructorSignaturePad"
				            />
			            </div>
			            <div class="col-md-6">
				            <div class="d-flex justify-content-between align-items-center mb-2">
					            <p class="fw-bolder m-0">Handtekening cursist</p>
					            <button type="button" class="btn btn-link" @click="$refs.participantSignaturePad.undoSignature()">{{ __('actions.undo') }}</button>
				            </div>
				            <VueSignaturePad
					            id="participantSignature"
					            width="100%"
					            height="300px"
					            ref="participantSignaturePad"
				            />
			            </div>
		            </div>
		            <div class="row mt-5 g-2 justify-content-start justify-content-md-end align-items-center">

                        <button type="submit" class="btn btn-wide btn-outline-success">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                            </svg>
                            {{ __('questionnaires.save') }}
                        </button>

		            </div>
                    <div class="row mt-2">
			            <div class="col-auto">
				            <p class="form-text">Status: {{ status }}</p>
			            </div>
		            </div>
	            </form>
	        </validation-observer>
		</main>
	</div>
</template>

<script>

import moment from "moment"
import { v4 as uuidv4 } from 'uuid';

export default {
	props: {
		questionnaireProp: {
			type: Object,
			required: true,
		},

		schedule: {
			type: Object,
			required: false,
		},

		user: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			questionnaire: this.questionnaireProp,
			filledQuestionnaire: this.filledQuestionnaireData(),
            savedDraftFilledQuestionnaire: null,
			loading: false,
            status: this.setInitialStatus(),
            offlineDrafts: null,
            showOfflineDrafts: true
		}
	},

	created() {
		this.initForm()

        if (localStorage[storageKey] === undefined) {
			localStorage[storageKey] = JSON.stringify([]);
		}
	},

    mounted: function () {
        this.filledQuestionnaire.offline_id = uuidv4()
		this.offlineDrafts = this.getFormsFromStorage(this.questionnaire.id)
        this.$nextTick(function () {
            setInterval(() => {
                //check some basic fields (mandatory in model)
                if (this.isAtLeastOneQuestionAnswered()){

                    this.saveFormLocally(true)
                    this.saveIncompleteDraft()

                    if (this.filledQuestionnaire.id == null)
                    {
                        //there isn't an id. Lets create one.
                        this.newDraft()
                    }
                    else
                    {
                        this.saveDraft()
                    }
                }
            }, 20000);
        })
    },

    computed: {
        start_session: {
            get () {
                return this.filledQuestionnaire.session_start
            },
            set (value) {
                this.filledQuestionnaire.session_start = value
                this.setSessionEndTime();
            }
        },
		topbarStyle: function() {
			return 'border-bottom: 1px solid red !important;'
		},

    },

	methods: {
        isAtLeastOneQuestionAnswered: function(){

            let answeredQuestions = 0;

            Array.from(this.filledQuestionnaire.answers).forEach(section => {

                Array.from(section.questions).forEach((question, index) => {

                    if (!((question['answer'] == null) || (question['answer'].length == 0))){
                        answeredQuestions++;
                    }
                })
            })

            return answeredQuestions > 0;
        },

        setSessionStartTime: function(direction = null){

            let date = new Date();
            let min = date.getMinutes();
			let alreadyRounded = false;

			if (min % 10 == 0){
				alreadyRounded = true
			}

			//console.log(alreadyRounded)
			//console.log("min = " + min)

            if (direction == "up"){
				if (alreadyRounded){
					min = min + 1;
				}
				//console.log("min = " + min)
                date.setMinutes(Math.ceil(min / 10) * 10);
            }

            if (direction == "down"){
				if (alreadyRounded){
					min = min - 1;
				}
				//console.log("min = " + min)
                date.setMinutes(Math.floor(min / 10) * 10);
            }

            this.filledQuestionnaire.session_start = moment(date).format("HH:mm")
            this.setSessionEndTime();
        },
        restoreFromLocalDraft: function(id){
            Swal.fire({
                title: this.__('actions.confirm-restore-offline'),
                text: this.__('actions.confirm-text-restore-offline'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes-restore-offline'),
                cancelButtonText:  this.__('actions.confirm-no-restore-offline'),
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true
            }).then((result) => {

                if (result.isConfirmed) {
                    this.offlineDrafts.forEach((draft) => {
                        if (id == draft.offline_id){
                            this.filledQuestionnaire = draft.data
                            this.showOfflineDrafts = false

                            Swal.fire(
                                'Gelukt!',
                                'De gegevens van het automatisch opgeslagen formulier zijn opgehaald.',
                                'success'
                            )
                        }
                    })
                }
            })
        },
        deleteFromLocalDraftWithConfirmation: function(id){
            Swal.fire({
                title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes'),
                cancelButtonText:  this.__('actions.confirm-no'),
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true
            }).then((result) => {

                if (result.isConfirmed) {

                    if (this.deleteFromLocalDraft(id) === true){
                        Swal.fire(
                            'Gelukt!',
                            'Het bewaarde formulier is verwijderd.',
                            'success'
                        )
                    }else{
                        Swal.fire(
                            'Niet gelukt...',
                            'Het bewaarde formulier is niet verwijderd.',
                            'error'
                        )
                    }
                }
            })
        },
        deleteFromLocalDraft: function(id){

            let data = this.getFormsFromStorage(null)
            let isSuccess = false

            data.forEach((draft, index) => {

                if (id == draft.offline_id){
                    data.splice(index, 1);
                    localStorage[storageKey] = JSON.stringify(data);

                    this.offlineDrafts = this.getFormsFromStorage(this.questionnaire.id)
                    isSuccess = true
                }
            })

            return isSuccess

        },
        setInitialStatus: function(){
            return 'Nieuw (concept nog niet opgeslagen)'
        },
        getFormsFromStorage: function(questionnaireId){
            if (questionnaireId == null){
                return JSON.parse(localStorage[storageKey])
            }

            return JSON.parse(localStorage[storageKey]).filter(
                                                        value => value.is_draft === true
                                                        && value.questionnaire_id == questionnaireId
                                                        && value.offline_id !== this.filledQuestionnaire.offline_id)
        },
        newDraft: function(){
            let url = '/questionnaire/new-draft';
            if (navigator.onLine) {
                axios.post(url, this.filledQuestionnaire).then(response => {
                    this.filledQuestionnaire.id = response.data.id
                    this.status = "Draft aangemaakt (" + response.data.date + ")"
                }).catch(error => {
                    console.log(error);
                });
            }
        },

        saveDraft: function(){
            let url = '/questionnaire/save-draft';
            if (navigator.onLine) {
                axios.post(url, this.filledQuestionnaire).then(response => {
                    this.status = "Draft opgeslagen (" + response.data.date + ")"
                }).catch(error => {
                    console.log(error);
                });
            }
        },

		saveIncompleteDraft: function(){
            let url = '/questionnaire/save-incomplete-draft';
            if (navigator.onLine) {
                axios.post(url, this.filledQuestionnaire).then(response => {
                    this.status = "Draft opgeslagen"
                }).catch(error => {
                    console.log(error);
                });
            }
        },

		calculateScoreHandler: function(){

			Array.from(this.filledQuestionnaire.answers).forEach(section => {

				let eligibleQuestionCount = 0;
				let filledQuestionCount = 0;
				let sectionTotal = 0;
				let sectionDontShowCounter = 0;

				Array.from(section.questions).forEach((answer, index) => {

					if (answer['type'] === '3_POINT_GRADING_SCALE' || answer['type'] === '4_POINT_GRADING_SCALE') {
						eligibleQuestionCount++

						Array.from(answer.options).forEach(option => {
							if (option['body'] === answer['answer'])
                            {
								filledQuestionCount++
								sectionTotal = sectionTotal + option['attribute'];
							}
						})

						if (answer['answer'] == '' || answer['answer'] == null){
							sectionDontShowCounter++
						}
					}

					if (eligibleQuestionCount > 0 && sectionDontShowCounter == 0)
                    {
						section.averageScore = (sectionTotal / filledQuestionCount).toFixed(1);
					}
					else
                    {
                        //looks like a fuzzy else,
                        //but is necessary to prevent showing the averageScore too early
						section.averageScore = '';
					}
				})
			})

			let subTotal = 0;
			let eligibleSectionCount = 0;

			//loop again, to get every set sectionAverage
			Array.from(this.filledQuestionnaire.answers).forEach(section => {

				if (section.averageScore > 0)
				{
					subTotal += parseFloat(section.averageScore);
					eligibleSectionCount++;
				}

			})
			this.filledQuestionnaire.totalAverageScore = (subTotal / eligibleSectionCount).toFixed(1);
		},
        setSessionEndTime: function (){
            this.filledQuestionnaire.session_end = moment(this.filledQuestionnaire.session_start, "hh:mm").add(90, 'minutes').format("HH:mm")
        },
		saveForm: async function () {

            const isValid = await this.$refs.observer.validate();

            if (!isValid)
            {
                const el = document.querySelector(".invalid-feedback"); //select first validation error
                el.scrollIntoView({block: "center"});

                return
            }

            if (this.user.instructor_signature === null && await this.instructorSignatureFilled()) {
                return
            }

            if (await this.participantSignatureFilled()) {
                return
            }

            this.loading = true
            let url = '/questionnaire/fill';
            if (navigator.onLine) {
                axios.post(url, this.filledQuestionnaire).then(response => {
                    this.deleteFromLocalDraft(this.filledQuestionnaire.offline_id)
                    Toast.fire({icon: 'success', title: response.data.message})
                    this.loading = false
                    this.filledQuestionnaire = this.filledQuestionnaireData()
                    this.initForm()
                    this.$refs.observer.reset();
                    this.$refs.participantSignaturePad.clearSignature()
                    if (this.schedule) {
                        window.location.href='/upcoming';
                    }
                }).catch(error => {
                    console.log(error);
                });
            } else {

                this.saveFormLocally(false)

                Toast.fire({icon: 'warning', title: this.__('questionnaires.synced-back-online') })

                this.loading = false
                this.filledQuestionnaire = this.filledQuestionnaireData()
                this.initForm()
                this.$refs.observer.reset();
                this.$refs.participantSignaturePad.clearSignature()
            }

		},

        saveFormLocally: function(isDraft=true)
        {
            let url = '/questionnaire/fill';
            // initializing the localStorage for the plugin
            if (localStorage[storageKey] === undefined) {
                    localStorage[storageKey] = JSON.stringify([]);
                }

                // retrieve data waiting to be sent
                let data = JSON.parse(localStorage[storageKey]);

                // removes empty records and remove current form (in order to add it later in this method)
                if(data.length) {
                    data.forEach((value, index) => {
                        if(value === null) {
                            data.splice(index, 1);
                        }

                        if (value.offline_id == this.filledQuestionnaire.offline_id)
                        {
                            data.splice(index, 1);
                        }
                    });
                }

                // add the serialized form to the data
                data.push({
                    url: url,
                    is_draft: isDraft,
                    data: this.filledQuestionnaire,
                    questionnaire_id: this.questionnaire.id,
                    offline_id: this.filledQuestionnaire.offline_id,
                    updated_at: new Date().getTime(),
                    method: 'POST'
                });

                // store the new data
                localStorage[storageKey] = JSON.stringify(data);
        },

		filledQuestionnaireData: function() {
			return {
                id: null,
				title: '',
                company_name: '',
                project_code: '',
                profile_number: '',
				participant_name: '',
                participant_email: '',
                participant_phone: '',
				location: '',
				date: null,
				instructor_name: '',
				wrm_number: '',
				has_valid_driver_license: true,
                has_passed: null,
				session_start: null,
				session_end: null,
				answers: [],
				instructor_signature: null,
				participant_signature: null,
				schedule_id: null,
                was_present: true,
                footer_text: ''
			}
		},

		initForm: function() {
            this.status = this.setInitialStatus()
			this.filledQuestionnaire.title = this.questionnaire.name
            this.filledQuestionnaire.instructor_name = this.user.name
            this.filledQuestionnaire.footer_text = this.questionnaire.footer_text
			this.filledQuestionnaire.wrm_number = this.user.wrm_number
			this.filledQuestionnaire.instructor_signature = this.user.instructor_signature
			this.filledQuestionnaire.answers = this.questionnaire.questions.map(section => {
				section.questions.map(question => {
					if (question.type === 'MULTI_CHOICE') {
						question.answer = []
					} else {
						question.answer = null
					}
					return question
				})

				return section
			})
			this.filledQuestionnaire.date = moment().format('YYYY-MM-DD')
			if (this.schedule) {
				this.filledQuestionnaire.company_name = this.schedule.company_name
                this.filledQuestionnaire.profile_number = this.schedule.profile_number
                this.filledQuestionnaire.project_code = this.schedule.project_code
				this.filledQuestionnaire.participant_name = this.schedule.participant_name
                this.filledQuestionnaire.participant_email = this.schedule.participant_email
                this.filledQuestionnaire.participant_phone = this.schedule.participant_phone
				this.filledQuestionnaire.location = this.schedule.location
				this.filledQuestionnaire.date = moment(this.schedule.start_date).format('YYYY-MM-DD')
				this.filledQuestionnaire.session_start = moment(this.schedule.start_date).format('HH:mm')
				this.filledQuestionnaire.schedule_id = this.schedule.id
                this.filledQuestionnaire.was_present = this.filledQuestionnaire.was_present

                this.setSessionEndTime();
			}
		},

		instructorSignatureFilled: function () {
			const { isEmpty, data } = this.$refs.instructorSignaturePad.saveSignature();
			if (isEmpty) {
				Toast.fire({icon: 'error', title: this.__('questionnaires.signature-instructor-missing')})
			} else this.filledQuestionnaire.instructor_signature = data

			return isEmpty
		},

		participantSignatureFilled: function () {
			const { isEmpty, data } = this.$refs.participantSignaturePad.saveSignature();
			if (isEmpty && this.filledQuestionnaire.was_present) {
				Toast.fire({icon: 'error', title: this.__('questionnaires.signature-driver-missing')})
			} else this.filledQuestionnaire.participant_signature = data

            if (!this.filledQuestionnaire.was_present){
                this.filledQuestionnaire.participant_signature = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                return false
            }
			return isEmpty
		},
	}
}
</script>

<style>
#participantSignature, #instructorSignature {
	border: double 3px transparent;
	border-radius: 5px;
	background-image: linear-gradient(white, white),
	linear-gradient(white, white);
	background-origin: border-box;
	background-clip: content-box, border-box;
}

.btn-wide{
    width: 100%;
    background-color: #4aa1cb;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
}

.btn-wide:hover{
    color: #fff;
}

.bar-score-negative {
	border: 0;
    height: 5px !important;
    background-image: linear-gradient(to right, rgba(255, 0, 0, 1.0), rgba(255, 0, 0, 0.85), rgba(255, 0, 0, 1.0));
}

.bar-score-positive {
	border: 0;
    height: 5px !important;
    background-image: linear-gradient(to right, rgba(0, 255, 0, 1.0), rgba(0, 255, 0, 0.85), rgba(0, 255, 0, 1.0));
}

.option-na-input{
    margin-left:10px !important;
}

.option-na-label{
    margin-left:5px;
    font-style: italic;
}

.time-setter{
    margin-right: 6px;
    padding: 1px 10px;
    background-color: #a0becd;
    cursor: pointer;
    border-radius: 4px;
    color: #fff;
}
</style>
